import { render, staticRenderFns } from "./connect-login.vue?vue&type=template&id=44d72e6f"
import script from "./connect-login.ts?vue&type=script&lang=js&external"
export * from "./connect-login.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { Loader as VivaLoader } from '@/core/components'
installComponents(component, {VivaLoader})
